module.exports = __webpack_public_path__ + "img/winerack11.307f7dd9.jpg";